<template>
  <div id="listWidget" class="mb-5">
    <!-- <h4 class="mb-3">온도 조절기 설정</h4> -->
    <div class="row">
      <div class="col-xl-6">
        <div class="text-muted fs-12px mb-2"><b>온도조절기</b></div>
        <div class="list-group mb-3">
          <ListGroupItem class="card-item mb-2" style="border-radius: 1.2rem; border-top: none !important;" @click="onSettingTempRegistClick">
            <div class="flex-fill">
              <div class="fw-600">온도조절기 등록</div>
              <div class="fs-12px text-muted">
                온도조절기를 등록할 수 있습니다.
              </div>
            </div>
            <div>
              <div class="form-switch">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </ListGroupItem>
          <ListGroupItem class="card-item mb-2" style="border-radius: 1.2rem; border-top: none !important;" @click="onSettingTempListClick">
            <div class="flex-fill">
              <div class="fw-600">온도조절기 관리</div>
              <div class="fs-12px text-muted">
                온도조절기를 삭제할 수 있습니다.
              </div>
            </div>
            <div>
              <div class="form-switch">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </ListGroupItem>
          <!-- <ListGroupItem style="border-radius: 1.2rem; margin-bottom: 4px;" @click="onSettingTempScheduleClick">
            <div class="flex-fill">
              <div class="fw-600">온도조절기 예약</div>
              <div class="fs-12px text-muted">
                온도조절기를 예약설정 할 수 있습니다.
              </div>
            </div>
            <div>
              <div class="form-switch">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </ListGroupItem> -->
        </div>

          <div class="text-muted fs-12px mb-2"><b>컨트롤러</b></div>
          <div class="list-group">
          <ListGroupItem class="card-item mb-2" style="border-radius: 1.2rem; border-top: none !important;" @click="onTransferChangeWifiClick">
            <div class="flex-fill">
              <div class="fw-600">와이파이 변경</div>
              <div class="fs-12px text-muted">
                설치된 지역의 Wifi가 변경되었을 때 변경된 wifi 정보를
                온도조절기에 재설정 합니다.<br>
                <span class="text-danger">기존에 설치된 온도조절기의 wifi 셋팅 정보를 변경할때만 사용하십시오.</span>
              </div>
            </div>
            <div>
              <div class="form-switch">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </ListGroupItem>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';
import {
  getCurrentInstance,
  onBeforeMount,
  onBeforeUnmount,
  computed,  
} from 'vue';
const { emitter, mobile, logger } =
  getCurrentInstance().appContext.config.globalProperties;
const router = useRouter();

const onSettingTempRegistClick = () => router.push('/settings/temp/regist');
const onSettingTempListClick = () => router.push('/settings/temp/list');
const onSettingTempScheduleClick = () => router.push('/settings/temp/schedule');
const onTransferChangeWifiClick = () => router.push('/settings/temp/change/wifi');

onBeforeMount(() => {  
  emitter.emit('onChangeHeaderSetting',{title:'온도 조절기 설정',isShowMenu:false,isShowZone:false,isShowProfile:false,isShowRightHome:true});    
});
onBeforeUnmount(() =>{
  emitter.emit('onChangeHeaderSetting',{title:'',isShowMenu:true,isShowZone:true,isShowProfile:true,isShowRightHome:false});  
})
</script>
